module.exports = __webpack_public_path__ + "img/widget_logo.aefb6d83.png";